const info = {
    30:{
        0:{
            0:"",
            1:{
                number:208,
                id:"sylph-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/sylph-male-warrior.mp4",
                image:""
            },
            2:""
        },
        1:{
            0:"",
            1:{
                number:208,
                id:"sylph-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/sylph-female-warrior.mp4",
                image:""
            },
            2:""
        }
    },
    5:{
        0:{
            0:"",
            1:{
                number:192,
                id:"kamael-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/kamael-male-warrior.mp4",
                image:""
            },
            2:""
        },
        1:{
            0:"",
            1:{
                number:192,
                id:"kamael-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/kamael-female-warrior.mp4",
                image:""
            },
            2:""
        }
    },
    0:{
        0:{
            0:{
                number:196,
                id:"human-male-death",
                video:"https://vod.plaync.com/lineage2/sylphserver/human-male-death.mp4",
                image:""
            },
            1:{
                number:0,
                id:"human-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/human-male-warrior.mp4",
                image:""
            },
            2:{
                number:10,
                id:"human-male-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/human-male-wizard.mp4",
                image:""
            }
        },
        1:{
            0:"",
            1:{
                number:0,
                id:"human-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/human-female-warrior.mp4",
                image:""
            },
            2:{
                number:10,
                id:"human-female-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/human-female-wizard.mp4",
                image:""
            }
        }
    },
    1:{
        0:{
            0:{
                number:200,
                id:"elf-male-death",
                video:"https://vod.plaync.com/lineage2/sylphserver/elf-male-death.mp4",
                image:""
            },
            1:{
                number:18,
                id:"elf-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/elf-male-warrior.mp4",
                image:""
            },
            2:{
                number:25,
                id:"elf-male-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/elf-male-wizard.mp4",
                image:""
            }
        },
        1:{
            0:"",
            1:{
                number:18,
                id:"elf-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/elf-female-warrior.mp4",
                image:""
            },
            2:{
                number:25,
                id:"elf-female-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/elf-female-wizard.mp4",
                image:""
            }
        }
    },
    2:{
        0:{
            0:{
                number:204,
                id:"darkelf-male-death",
                video:"https://vod.plaync.com/lineage2/sylphserver/dark-male-death.mp4",
                image:""
            },
            1:{
                number:31,
                id:"eldarkf-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/dark-male-warrior.mp4",
                image:""
            },
            2:{
                number:38,
                id:"edarklf-male-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/dark-male-wizard.mp4",
                image:""
            }
        },
        1:{
            0:"",
            1:{
                number:31,
                id:"eldarkf-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/dark-female-warrior.mp4",
                image:""
            },
            2:{
                number:38,
                id:"edarklf-female-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/dark-female-wizard.mp4",
                image:""
            }
        }
    },
    3:{
        0:{
            0:"",
            1:{
                number:44,
                id:"oak-male-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/oak-male-warrior.mp4",
                image:""
            },
            2:{
                number:49,
                id:"oak-male-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/oak-male-wizard.mp4",
                image:""
            }
        },
        1:{
            0:"",
            1:{
                number:44,
                id:"oak-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/oak-female-warrior.mp4",
                image:""
            },
            2:{
                number:49,
                id:"oak-female-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/oak-female-wizard.mp4",
                image:""
            }
        }
    },
    4:{
        0:{
            0:"",
            1:{
                number:53,
                id:"dwarf-female-warrior",
                video:"https://vod.plaync.com/lineage2/sylphserver/dwarf-male-warrior.mp4",
                image:""
            },
            2:""
        },
        1:{
            0:"",
            1:{
                number:53,
                id:"dwarf-female-wizard",
                video:"https://vod.plaync.com/lineage2/sylphserver/dwarf-female-warrior.mp4",
                image:""
            },
            2:""
        }
    }
};

export default info;


// WEBPACK FOOTER //
// ./src/js/create/video-info.js